import { useState } from 'react';
import StudentSearch from '../molecules/StudentSearch';
import SearchResultRowWithIndicator from '../atoms/SearchResultRowWithIndicator';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Link } from 'react-router-dom';
import { useAddAttendanceByName } from '../../hooks/events.hook';

const AddToEventByName = ({ eventInfo }) => {
  const [searchString, setSearchString] = useState('');
  const { data, addUserMutation } = useAddAttendanceByName(searchString);

  return (
    <>
      <div>Search by student name / ID</div>

      <div className='my-4'>
        <StudentSearch setSearchString={setSearchString} />
      </div>

      <div>
        {data && (
          <>
            <div className='pt-5 font-bold'>
              <div>Click student's name to add attendance:</div>
            </div>
            <div className='pb-4 text-xs italic text-gray-600'>
              Green ticks indicate that attendance has been recorded for this
              event
            </div>

            <div>
              {Array.isArray(data) ? (
                // DISPLAY SEARCH RESULTS
                data?.map(student => {
                  return (
                    <SearchResultRowWithIndicator
                      key={student.student_id}
                      Icon={student.attendance_date ? CheckCircleIcon : ''}
                      color='success'
                    >
                      <Link
                        className='noUnderline'
                        onClick={() =>
                          addUserMutation.mutate(student.student_id)
                        }
                      >
                        {student.student_first_name} {student.student_last_name}
                      </Link>
                    </SearchResultRowWithIndicator>
                  );
                })
              ) : (
                <div>No results found</div>
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AddToEventByName;
